const filtersReducer = (state = {}, action) => {
  switch (action.type) {
    case 'test':
      return {
        ...state,
      };
    default:
      return state;
  }
};

export { filtersReducer }
